import { MessageCircle } from "lucide-react";

export default function WhatsAppFloat() {
  return (
    <a
      href="https://wa.me/917624853840?text=Hello%20Mutha%20Paras%20%26%20Co.%2C%20I%20am%20interested%20in%20your%20lining%20fabrics.%20Please%20share%20details."
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-btn"
      className="fixed bottom-6 right-4 sm:bottom-8 sm:right-6 z-50 flex items-center gap-2 text-white text-xs sm:text-sm font-medium pl-3 pr-4 py-2.5 sm:pl-4 sm:pr-5 sm:py-3 rounded-full shadow-lg transition-transform duration-300 hover:scale-105 group"
      style={{
        backgroundColor: '#25D366',
        fontFamily: "'Manrope', sans-serif",
        boxShadow: '0 4px 20px rgba(37, 211, 102, 0.4)',
      }}
    >
      {/* Pulse ring */}
      <span
        className="absolute inset-0 rounded-full animate-ping opacity-20"
        style={{ backgroundColor: '#25D366' }}
      />

      <MessageCircle className="w-5 h-5 relative" />
      <span className="relative hidden sm:inline">Order on WhatsApp</span>
    </a>
  );
}
